import { render, staticRenderFns } from "./ShiftVDPJournal.vue?vue&type=template&id=f2d6c57a&"
import script from "./ShiftVDPJournal.vue?vue&type=script&lang=ts&"
export * from "./ShiftVDPJournal.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftVDPJournal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports